export function Sparkline({ values, direction = "flat", width = 140, height = 40 }: {
  values: number[];
  direction?: "up" | "down" | "flat";
  width?: number;
  height?: number;
}) {
  if (values.length < 2) return <div className="sparkline-empty">暂无历史</div>;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const points = values.map((value, index) => {
    const x = (index / (values.length - 1)) * width;
    const y = height - 3 - ((value - min) / span) * (height - 6);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  return (
    <svg className={`sparkline direction-${direction}`} viewBox={`0 0 ${width} ${height}`} role="img" aria-label="历史走势">
      <line x1="0" y1={height - 1} x2={width} y2={height - 1} className="sparkline-baseline" />
      <polyline points={points} fill="none" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
